import { CrossIcon, Plus } from 'assets/icons';
import UseContext from 'hooks/useContext';
import Button from 'components/button';
import Banner from 'components/banner/banner';
import { fillText, perimeterText } from 'components/perimeter/perimeterText';

const TITLE_ID = 'contact-perimeters-title';

// The « Périmètres » block of the contact screen. It only shows the draft:
// the screen owns the list and sends it when the contact is saved.
const CompanyContactPerimeters = ({
  status,
  selectedPerimeters,
  isUnrestricted,
  error,
  onAdd,
  onRemove,
}) => {
  const { language } = UseContext();
  const t = (key) => perimeterText(language, key);
  const canEdit = status === 'ready' && !isUnrestricted;
  const hasPerimeters = canEdit && selectedPerimeters.length > 0;

  const subtitle = () => {
    if (isUnrestricted) return t('member.unrestricted');
    if (status === 'loading') return t('member.loading');
    if (status !== 'ready') return t('member.loadError');
    return t(hasPerimeters ? 'member.restricted' : 'member.none');
  };

  return (
    <div className={'flex flex-col gap-2'}>
      <section
        aria-labelledby={TITLE_ID}
        aria-disabled={isUnrestricted ? 'true' : undefined}
        data-testid={'contact-perimeters'}
        className={`rounded-lg border border-gray-200 ${
          isUnrestricted ? 'bg-gray-50' : ''
        }`}
      >
        <div className={'flex items-center justify-between gap-3 px-4 py-3'}>
          <div className={'min-w-0'}>
            <div
              id={TITLE_ID}
              className={isUnrestricted ? 'text-gray-500' : 'text-gray-900'}
            >
              {t('title')}
            </div>
            <div
              className={'text-gray-500'}
              data-testid={'contact-perimeters-subtitle'}
            >
              {subtitle()}
            </div>
          </div>
          <Button
            size={'ICON'}
            color={canEdit ? 'SECONDARY' : 'DISABLED'}
            disabled={!canEdit}
            onClick={onAdd}
          >
            <Plus wh={20} color={canEdit ? '#111827' : '#9CA3AF'} />
            <span className={'sr-only'}>{t('member.add')}</span>
          </Button>
        </div>
        {hasPerimeters ? (
          <ul className={'border-t border-gray-100'}>
            {selectedPerimeters.map((perimeter) => (
              <li
                key={perimeter.id}
                className={
                  'flex items-center justify-between gap-3 border-b border-dashed border-gray-100 px-4 py-2 last:border-b-0'
                }
              >
                <div
                  className={'truncate text-gray-900'}
                  title={perimeter.name}
                >
                  {perimeter.name}
                </div>
                <Button
                  size={'ICON'}
                  color={'SECONDARY'}
                  onClick={() => onRemove(perimeter.id)}
                >
                  <CrossIcon wh={20} color={'#111827'} />
                  <span className={'sr-only'}>
                    {fillText(t('member.remove'), { name: perimeter.name })}
                  </span>
                </Button>
              </li>
            ))}
          </ul>
        ) : null}
      </section>
      {error ? <Banner type={'alert'}>{error}</Banner> : null}
    </div>
  );
};

export default CompanyContactPerimeters;
